<template>
  <div class="login-container" @click="closeMask">
    <!-- <div class="nav">
      <div class="logo-container">
        <img src="@/assets/mobile/122322.png" alt="Logo" class="logo-image" />
        <span style="font-size: 12px !important; white-space: nowrap"
          >運命シンカー</span>
      </div>
      <div class="user-dropdown">
        <div class="user-header" @click.stop="toggleDropdown">
          <div
            class="user-name"
            style="
              font-family: Source Han Serif SC, Source Han Serif SC;
              max-width: 100px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 12px;
            "
          >
            {{ name }}
          </div>
          <i
            class="dropdown-icon"
            v-if="getUserType"
            :class="{ rotate: isDropdownOpen }"
          ></i>
        </div>
        <div class="dropdown-menu" :class="{ show: isDropdownOpen }">
          <div class="usage-info">
            <div class="usage-item">
              <i class="model-dot basic"></i>
              <span>残り解析回数</span>
              <b>{{ quota }}回</b>
            </div>
          </div>
          <div class="menu-actions">
            <button class="action-btn profile" @click="goToUserProfile">
              分析ログ
            </button>
            <button class="action-btn recharge" @click="goSubscription">
              定期でお得
            </button>
            <button class="action-btn purple" @click="goToInviteRewards">
              紹介報酬
            </button>
            <button class="action-btn logout" @click="logout">
              ログアウト
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <navbar></navbar>
    <!-- 使用须知弹窗 -->
    <div class="mask" v-if="currentStep === 'agreement'">
      <div class="mask-content">
        <div class="mask-pos" style=""></div>
        <div class="mask-title">使用须知</div>
        <div class="mask-text">
          <p>
            欢迎使用玄鑑 •
            AI命理プラットフォーム，请在使用前仔细阅读并同意以下条款:
          </p>
          <h3>一、服务内容与使用规则</h3>
          <ol>
            <li>
              <strong>娱乐性质声明：</strong>
              本系统所提供的八字、塔罗牌、紫微斗数等分析结果
              <u>完全</u>
              仅供娱乐参考，不构成任何形式的专业建议，亦不应被视为命理预测。
            </li>
            <li>
              <strong>决策风险提示：</strong>
              用户
              <u>严禁</u>
              将本系统的分析结果作为医疗、法律、投资、婚姻或其他重大人生决策的依据。任何基于本系统做出的决定及其后果，由用户自行承担全部责任。
            </li>
            <li>
              <strong>精准度免责：</strong>
              本系统基于人工智能技术，虽力求提供有价值的内容，但
              <u>明确声明</u>
              无法保证分析结果的准确性、完整性或适用性，用户对此予以充分理解并接受。
            </li>
            <li>
              <strong>个人解读差异：</strong>
              命理分析存在多种解读方式和流派差异，本系统采用的算法和理论仅代表特定解读视角，非唯一权威，不应被视为对用户未来的预测或承诺。
            </li>
          </ol>
          <h3>二、用户隐私与数据安全</h3>
          <ol>
            <li>
              <strong>隐私保护：</strong>
              您提供的生辰信息仅用于系统内分析，我们重视您的隐私保护，但不对第三方非法获取信息的行为承担法律责任。
            </li>
            <li>
              <strong>数据存储：</strong>
              您提供的生辰信息仅用于系统内分析，我们重视您的隐私保护，但不对第三方非法获取信息的行为承担法律责任。
            </li>
            <li>
              <strong>信息使用范围：</strong>
              除非获得您的明确授权或法律法规另有规定，我们不会向任何第三方披露您的个人信息。
            </li>
          </ol>
          <h3>三、用户责任与义务</h3>
          <ol>
            <li>
              <strong>合法使用：</strong>
              您应当遵守中华人民共和国相关法律法规，不得将本系统用于任何违法或不当目的。
            </li>
            <li>
              <strong>信息真实性：</strong>
              您有责任确保提供信息的真实性和准确性，因信息不实导致的分析偏差由用户自行负责。
            </li>
            <li>
              <strong>理性对待结果：</strong>
              用户应当以科学、理性的态度看待系统生成的内容，避免过度迷信或依赖。
            </li>
          </ol>
          <h3>四、服务变更与终止</h3>
          <ol>
            <li>
              <strong>服务调整：</strong>
              我们保留对本系统进行修改、升级或调整的权利。对于重大调整，我们会提前通知用户；仅在系统维护或紧急情况下，可能会临时暂停服务，并在恢复后及时告知。
            </li>
            <li>
              <strong>内容更新：</strong>
              本系统的算法模型和知识库可能会不定期更新，这可能导致分析结果发生变化。
            </li>
            <li>
              <strong>条款变更：</strong>
              本服务条款可能会不定期更新，更新后的条款将在用户下次使用时重新获得确认。
            </li>
          </ol>
          <h3>五、免责与争议解决</h3>
          <ol>
            <li>
              <strong>全面免责：</strong>
              对于因使用本系统而可能产生的任何直接或间接损失，包括但不限于心理伤害、决策失误、经济损失、名誉损害等，本系统及其开发者
              <u>明确且完全不承担任何责任</u>
            </li>
            <li>
              <strong>第三方链接：</strong>
              本系统可能包含第三方网站的链接，我们不对这些网站的内容和行为负责，用户须自行判断并承担相关风险。
            </li>
            <li>
              <strong>争议解决：</strong>
              因使用本系统而产生的任何疑问或争议，我们希望能通过友好沟通协商解决，请通过系统提供的反馈渠道与我们取得联系，我们将真诚对待并积极寻求合理解决方案。
            </li>
          </ol>
          <h3>六、其他规定</h3>
          <ol>
            <li>
              <strong>知识产权：</strong>
              本系统的所有内容，包括但不限于文字、图像、算法、界面设计等均受知识产权法律保护，未经许可不得以任何形式使用、复制或传播。
            </li>
            <li>
              <strong>授权范围：</strong>
              用户仅获得本系统的个人非商业使用权，不得对本系统进行反向工程、破解、复制、传播或用于任何商业目的。
            </li>
            <li>
              <strong>条款更新：</strong>
              我们有权随时修改本条款，修改后的条款将在系统内公布。您继续使用本系统将被视为已接受修改后的条款。
            </li>
            <li>
              <strong>最终解释权：</strong>
              本服务条款的最终解释权归本系统开发者所有。
            </li>
            <p class="disclaimer-emphasis">
              点击"我已了解并同意"即表示您确认已完整阅读、充分理解并无条件接受上述全部条款，并承诺理性看待本系统提供的内容。若您不同意上述任何条款，请立即停止使用本系统。
            </p>
          </ol>
        </div>
        <div class="agreement-actions">
          <div class="checkbox-container">
            <input type="checkbox" id="agreement" v-model="agreementChecked" />
            <label for="agreement">7天内不再提示</label>
          </div>
          <button
            class="agree-btn"
            :style="
              agreementScrolled
                ? 'background-color: #CAA87C; color: #332F2C;'
                : 'background-color: #332F2C; color: #BEBEBE;'
            "
            @click="agreeToTerms"
          >
            {{ agreementScrolled ? "同意并继续" : "请先阅读完整内容" }}
          </button>
        </div>
      </div>
    </div>

    <!-- 主页内容 -->
    <div class="home-content" v-if="currentStep === 'home'">
      <div class="login-success" v-if="showLoginSuccess">
        <div class="success-icon">
          <img
            src="@/assets/mobile/success.png"
            style="width: 100%; height: 100%"
          />
        </div>
        <div class="success-text">登录成功</div>
      </div>

      <!-- 八字测算模块 -->
      <div class="analysis-module">
        <div class="bagua-container">
          <img
            src="@/assets/mobile/bazi.png"
            alt="八卦图"
            class="bagua-image"
          />
        </div>

        <div class="module-title">
          <img
            src="@/assets/mobile/center_img.png"
            class="bagua-center-image"
          />
        </div>

        <div class="analysis-options">
          <div class="analysis-option">性格診断</div>
          <div class="analysis-option" style="white-space: nowrap">
            事業運
          </div>
          <div class="analysis-option" style="white-space: nowrap">
            金運診断
          </div>
          <div class="analysis-option" style="white-space: nowrap">
            恋愛・結婚運
          </div>
          <div class="analysis-option">健康チェック</div>
          <div class="analysis-option">今年の運勢</div>
        </div>
        <div class="ai-analysis-btn" @click="goToAnalysis('personality')">
          命理診断
        </div>
      </div>

      <!-- 六爻排盘模块 -->
      <div class="analysis-module">
        <div class="liuyao-container">
          <img
            src="@/assets/mobile/sixYao.png"
            alt="六爻图"
            class="liuyao-image"
          />
        </div>

        <div class="module-title">
          <img
            src="@/assets/mobile/six_center.png"
            class="bagua-center-image"
          />
        </div>

        <div class="analysis-options">
          <div class="analysis-option">吉凶占い</div>
          <div class="analysis-option">開運避災</div>
          <div class="analysis-option">事業と婚恋</div>
          <div class="analysis-option">人生運勢</div>
          <div class="analysis-option">決策と名声</div>
          <div class="analysis-option">商売運勢</div>
        </div>
        <div class="ai-analysis-btn" @click="goToAnalysis('ai')">
          卦象解析
        </div>
      </div>
      <!-- 断法测算模块 -->
      <div class="analysis-module">
        <div class="liuyao-container">
          <img
            src="@/assets/mobile/duanfa.png"
            class="liuyao-image"
          />
        </div>

        <div class="module-title">
          <img
            src="@/assets/mobile/duanfa_center.png"
            class="bagua-center-image"
          />
        </div>

        <div class="analysis-options">
          <div class="analysis-option">八字実戦</div>
          <div class="analysis-option">易経推命</div>
          <div class="analysis-option">面相解読</div>
          <div class="analysis-option">ナプキン箱秘術</div>
          <div class="analysis-option">はちじかいぶんかい</div>
          <div class="analysis-option">盲派の口訣</div>
        </div>
        <div class="ai-analysis-btn" @click="goToAnalysis('duanfa')">
          無料で表示
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logout, getUserInfo, recordPVUV } from "@/api/index";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import navbar from './components/navbar.vue'
export default {
  components: {navbar},
  data() {
    return {
      currentTime: new Date().toLocaleString(),
      currentStep: "home", // 'agreement', 'home', 'analysis'
      agreementChecked: false,
      agreementScrolled: false,
      showLoginSuccess: false,
      isDropdownOpen: false,
      name: localStorage.getItem("userName") || "ログイン|会員登録",
      r1AiQuota: 0,
      v3AiQuota: 0,
      quota: 0,
      // 分析页面
      analysisType: "",
      getUserType: false,
    };
  },
  computed: {},
  mounted() {
    if (localStorage.getItem("ACCESS_TOKEN") != undefined) {
      this.getUser();
      this.getUserType = true;
    }
    if (this.$route.query.channel != undefined) {
      localStorage.setItem("channel", this.$route.query.channel);
    }
    if(this.$route.query.inviteCode != undefined){
      localStorage.setItem("inviteCode", this.$route.query.inviteCode);
    }
    // FingerprintJS.load().then((fp) => {
    //   fp.get().then((result) => {
    //     const visitorId = result.visitorId;
    //     console.log(visitorId);
    //     localStorage.setItem("deviceNumber", visitorId);

    //   });
    // });
    this.PV();
    // 检查本地存储中是否有协议同意记录
    if (localStorage.getItem("hasShownLoginSuccess") === "true") {
      this.currentStep = "home";
    } else {
      this.checkAgreementStatus();
    }

    window.addEventListener("beforeunload", () => {
      controller.abort();
    });
    // 添加滚动监听
    this.$nextTick(() => {
      const maskTextElement = document.querySelector(".mask-text");
      if (maskTextElement) {
        maskTextElement.addEventListener("scroll", this.handleAgreementScroll);
      }
    });

    // 添加滚动监听
    this.$nextTick(() => {
      const maskTextElement = document.querySelector(".mask-text");
      if (maskTextElement) {
        maskTextElement.addEventListener("scroll", this.handleAgreementScroll);
      }
    });

    // 每分钟更新一次时间
    this.timeInterval = setInterval(() => {
      this.currentTime = new Date().toLocaleTimeString("zh-CN", {
        hour: "2-digit",
        minute: "2-digit",
      });
    }, 60000);
  },
  methods: {
    //记录PV UV
    PV() {
      recordPVUV().then((response) => {
        console.log(response, "resooooooo");
      });
    },
    closeMask() {
      this.isDropdownOpen = false;
    },
    getUser() {
      getUserInfo().then((res) => {
        console.log(res, "res");
        this.quota = res.data.quota;
        if(res.data.agentId != null){
          localStorage.setItem("agentId", res.data.agentId);
        }
      });
    },
    logout() {
      logout().then((res) => {
        // this.name = 'ログイン|会員登録'
        this.getUserType = true;
        localStorage.removeItem("ACCESS_TOKEN");
        localStorage.removeItem("userName");
        localStorage.removeItem("agreementStatus");
        // this.$router.push("/mobile_home");
        window.location.reload();
      });
    },
    toggleDropdown() {
      if (localStorage.getItem("ACCESS_TOKEN") == undefined) {
        this.$router.push("/mobile_login");
        return;
      }
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    goToUserProfile() {
      this.$router.push("/analysis-records");
      this.isDropdownOpen = false; // 关闭下拉菜单
    },

    goSubscription() {
      // 跳转到定期でお得页面
      localStorage.removeItem("userBirthInfo")
      localStorage.removeItem("sixYao")
      this.$router.push("/subscription");
    },
    goToInviteRewards() {
      // 跳转到紹介報酬页面
      this.$router.push("/invite-rewards");
      this.isDropdownOpen = false;
    },
    goToFeedback() {
      // 跳转到意见反馈页面
      this.$router.push("/feedback");
    },

    updateTime() {
      this.currentTime = new Date()
        .toLocaleString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(/\//g, "-");
    },
    handleAgreementScroll(event) {
      const element = event.target;
      // 检查是否滚动到底部（考虑一点误差）
      const isAtBottom =
        Math.abs(
          element.scrollHeight - element.scrollTop - element.clientHeight
        ) < 5;
      this.agreementScrolled = true;
    },

    checkAgreementStatus() {
      // 从localStorage获取协议同意状态
      const agreementStatus = localStorage.getItem("agreementStatus");
      if (agreementStatus) {
        const { expireTime } = JSON.parse(agreementStatus);
        // 检查是否在有效期内
        if (expireTime > Date.now()) {
          // 如果协议同意状态有效，直接进入主页
          this.currentStep = "home";

          // 检查是否已经显示过登录成功提示
          const hasShownLoginSuccess = localStorage.getItem(
            "hasShownLoginSuccess"
          );
          if (!hasShownLoginSuccess) {
            // 如果没有显示过，则显示登录成功提示
            this.showLoginSuccess = true;
            setTimeout(() => {
              this.showLoginSuccess = false;
            }, 2000);
            // 记录已经显示过登录成功提示
            localStorage.setItem("hasShownLoginSuccess", "true");
          }
        }
      }
    },

    agreeToTerms() {
      console.log(this.agreementScrolled, "agreementScrolled");
      if (!this.agreementScrolled) {
        // 如果没有滚动到底部，提示用户
        alert("完全な内容をお読みください");
        return;
      } else {
        this.currentStep = "home";
        localStorage.setItem("agreementChecked", "true");
        localStorage.setItem("hasShownLoginSuccess", "true");
      }

      if (this.agreementChecked) {
        // 如果用户勾选了"7天内不再提示"
        const expireTime = Date.now() + 7 * 24 * 60 * 60 * 1000; // 7天后的时间戳
        localStorage.setItem("agreementStatus", JSON.stringify({ expireTime }));
        // 直接进入主页
        this.currentStep = "home";

        // 检查是否已经显示过登录成功提示
        const hasShownLoginSuccess = localStorage.getItem(
          "hasShownLoginSuccess"
        );
        if (!hasShownLoginSuccess) {
          // 如果没有显示过，则显示登录成功提示
          this.showLoginSuccess = true;
          setTimeout(() => {
            this.showLoginSuccess = false;
          }, 2000);
          // 记录已经显示过登录成功提示
          localStorage.setItem("hasShownLoginSuccess", "true");
        }
      } else {
        // 提示用户需要勾选同意
        // alert("请先勾选同意条款");
      }
    },
    goToAnalysis(type) {
      this.analysisType = type;
      if(type === "ai"){
        this.$router.push({
        path: "/liuyao-analysis",
        })
      }else if(type === "personality"){
        this.$router.push({
        path: "/edit-birth-info",
      });
      }else{
        this.$router.push({
          path: "/duanfa-analysis", 
        })
      }
      // 直接跳转到对应的分析页面，不再需要传递用户信息
      // 直接跳转到八字分析页面，不存储生辰信息
      // localStorage.setItem("analysisType", true);
     
    },
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  height: 100%;
  width: 100%;
  position: relative;
  background: #0e1313;
  overflow: hidden;
  background-image: url("../../assets/mobile/dateBack.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
}

.logo-container {
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
}

.logo-image {
  height: 32px;
  width: 32px;
  animation: rotate 30s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* font-family: kunpeng; */
  font-weight: 400;
  font-size: 16px;
  color: #caa87c;
  padding: 0 20px;
  text-align: right;
  height: 56px;
}

.user-dropdown {
  position: relative;
  cursor: pointer;
}
.user-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dropdown-icon {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid rgba(255, 255, 255, 0.6);
  margin-left: 6px;
  transition: transform 0.3s ease;
}

.dropdown-icon.rotate {
  transform: rotate(180deg);
}

.dropdown-menu {
  display: none;
}

.dropdown-menu.show {
  display: block;
}
.dropdown-menu {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  width: 240px;
  background: #000000d9;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(222, 184, 135, 0.2);
  border-radius: 8px;
  padding: 16px;
  opacity: 0;
  transform: translateY(-10px);
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
}
.show {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}
.usage-info {
  padding-bottom: 13px;
  border-bottom: 1px solid rgba(222, 184, 135, 0.1);
  margin-bottom: 16px;
}
.usage-item {
  display: flex;
  align-items: center;
  gap: 8px;
  /* padding: 8px 0; */
  color: #fffc;
  font-size: 14px;
  font-family: Source Han Serif SC-Regular;
}
.usage-item b {
  margin-left: auto;
  color: #deb887e6;
}
.menu-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.action-btn {
  width: 100%;
  padding: 9px;
  border-radius: 6px;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.profile {
  background: #93c5fd33;
  color: #93c5fde6;
  border: 1px solid rgba(147, 197, 253, 0.3);
}
.recharge {
  background: #deb88733;
  color: #deb887e6;
  border: 1px solid rgba(222, 184, 135, 0.3);
}
.purple {
  background: #a78bfa33;
  color: #a78bfae6;
  border: 1px solid rgba(167, 139, 250, 0.3);
}
.logout {
  background: #ff63471a;
  color: #ff6347e6;
  border: 1px solid rgba(255, 99, 71, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 36px;
}
.action-btn:hover,
.action-btn.active {
  background-color: rgba(202, 168, 124, 0.4);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mask-content {
  width: 90%;
  height: 80%;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
  color: #caa87c;
  overflow: hidden;
  border-radius: 10px;
}
/* .mask-pos {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(to bottom, #00000000, #0000001a),
    radial-gradient(circle at 20% 20%, rgba(0, 0, 0, 0.15), transparent 70%),
    radial-gradient(circle at 80% 80%, rgba(0, 0, 0, 0.15), #00000091 70%);
  z-index: 0;
  border: 2px solid black;
} */
.mask-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("../../assets/dateBack.png");
  background-repeat: no-repeat;
  background-size: cover;
  z-index: -2;
}

.mask-content::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
}

.mask-title {
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
  z-index: 1;
}

.mask-text {
  flex: 1;
  font-size: 14px;
  z-index: 1;
  overflow-y: auto;
  z-index: 1000;
  color: #ffffffe6;
  line-height: 1.6;
  position: relative;
}
.mask-text h3 {
  color: #deb887e6;
  border-bottom: 1px solid rgba(222, 184, 135, 0.3);
  padding-bottom: 0.5rem;
  /* font-family: var(--font-family-decorative); */
  letter-spacing: 1px;
  font-size: 15px;
  margin: 19px 10px;
}
.mask-text p {
  margin-bottom: 10px;
  z-index: 1;
}
.mask-text ol {
  padding-left: 24px;
  margin-bottom: 16px;
}
.agreement-actions {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
}
.disclaimer-emphasis {
  color: #deb887e6;
  font-weight: 500;
  border-left: 3px solid rgba(222, 184, 135, 0.6);
  padding-left: 16px;
  margin-top: 24px;
}
.checkbox-container {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
  font-size: 12px;
  color: #caa87c;
}

.checkbox-container input {
  margin-right: 8px;
}

.agree-btn {
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  font-family: Source Han Serif SC, Source Han Serif SC;
  font-weight: 400;
  font-size: 12px;
  transition: all 0.3s ease;
}

/* 主页内容样式 */
.home-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  height: calc(100% - 56px);
  position: relative;
  overflow-y: auto;
}

.login-success {
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 4px 16px;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 5;
  box-shadow: 0 0 20px rgba(202, 168, 124, 0.2);
  border: 1px solid rgba(202, 168, 124, 0.3);
}

.success-icon {
  font-size: 13px;
  color: #caa87c;
  margin-right: 10px;
  width: 13px;
  height: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.analysis-module {
  width: 100%;
  margin-bottom: 30px;
  padding: 20px 15px;
  background: #332f2ca3;
  border-radius: 10px;
  animation: fadInUp 1s cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes fadInUp {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.bagua-container,
.liuyao-container {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.bagua-image,
.liuyao-image {
  width: 60px;
  height: 60px;
  padding: 5px;
  animation: rotate 30s linear infinite;
}

.bagua-center-image {
  width: auto;
  height: 45px;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.module-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.title-text {
  font-size: 22px;
  color: #caa87c;
  font-family: "Source Han Serif SC", serif;
  margin: 0 10px;
}

.title-line {
  height: 1px;
  background: linear-gradient(to right, transparent, #caa87c, transparent);
  width: 60px;
}

.analysis-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  width: 100%;
  position: relative;
  z-index: 1;
}

.analysis-option {
  color: #caa87c;
  padding: 12px 0;
  text-align: center;
  border-radius: 20px;
  /* font-family: Source Han Serif SC-Regular; */
  font-weight: 400;
  font-size: 13px;
  color: #e8c89e;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  z-index: 5;
}

/* .analysis-option:active {
  background-color: rgba(202, 168, 124, 0.2);
} */

.analysis-option::before {
  content: "";
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  height: 7px;
  border-radius: 16px;
  /* background: #332f2ca3; */
  background: #332f2c;

  border: 1px solid #caa87c;
  width: 95%;
  margin: 0 auto;
  z-index: -1;
}

.ai-analysis-btn {
  background-color: #caa87c;
  color: #0e1313;
  padding: 15px 0;
  text-align: center;
  border-radius: 40px;
  margin: 30px 30px 0 30px;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 10px rgba(202, 168, 124, 0.3);
  transition: all 0.3s ease;
}

.ai-analysis-btn:active {
  background-color: #b99b70;
  transform: scale(0.98);
}

.more-features-btn::before {
  content: "";
  display: inline-block;
  width: 10px;
  height: 10px;
  border: solid #caa87c;
  border-width: 0 0 2px 2px;
  transform: rotate(-45deg);
  margin-right: 8px;
  position: relative;
  top: -4px;
}
</style>
